module.exports = __webpack_public_path__ + "static/circularstd-book-d356ee6e9377e36166652b0dab169354.woff";